import React from "react";
import { Phone, CalendarHeart, MapPin } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";
import { Link } from "react-router-dom";

const PHONE = "450-736-0748";
const MAPS = "https://www.google.com/maps/dir/?api=1&destination=4825+rue+Cyrille+Delage+Laval+QC";

export default function MobileStickyBar() {
  const { t } = useI18n();
  return (
    <div className="xl:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 border-t border-black/10 bg-white shadow-[0_-2px_12px_rgba(0,0,0,0.08)]"
      data-testid="mobile-sticky-bar">
      <a href={`tel:${PHONE}`} data-testid="sticky-call"
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 py-2 text-xs font-semibold text-[#2D3142]">
        <Phone className="h-5 w-5 text-[#2A9D8F]" /> {t("common.call")}
      </a>
      <Link to="/contact" data-testid="sticky-visit"
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 border-x border-black/10 bg-[#2A9D8F] py-2 text-xs font-semibold text-white">
        <CalendarHeart className="h-5 w-5" /> {t("common.planVisit")}
      </Link>
      <a href={MAPS} target="_blank" rel="noopener noreferrer" data-testid="sticky-directions"
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 py-2 text-xs font-semibold text-[#2D3142]">
        <MapPin className="h-5 w-5 text-[#2A9D8F]" /> {t("common.directions")}
      </a>
    </div>
  );
}
